import { Injectable } from '@angular/core';
import { ApplicationProfilePortalTheme } from '@app/@shared/models';
import { mapToApplicationProfilePortalTheme } from '@app/auth';
import { BaseApiService } from '@ep/shared';
import { catchError, map, of } from 'rxjs';
import { EnrollmentResponse, MapEnrollmentResponseToEnrollmentData } from './enrollment.service';

interface CoalitionThemeResponse {
  theme: ApplicationProfilePortalTheme;
  coalitionName: string;
}

@Injectable({
  providedIn: 'root',
})
export class RegistrationService extends BaseApiService {
  private readonly coalitionEndpoint = '/v2/Coalition';
  private readonly enrollmentEndpoint = '/v2/Enrollments';

  getCoalitionTheme(coalitionId: string) {
    return this.get<CoalitionThemeResponse>(`${this.coalitionEndpoint}/get-coalition-theme/${coalitionId}`).pipe(
      catchError((err) => {
        console.error(err);
        return of({} as CoalitionThemeResponse);
      }),
      map((response) => ('theme' in response ? mapToPortalTheme(response.theme, response.coalitionName) : null))
    );
  }

  getCoalitionThemeByEnrollmentId(enrollmentId: string) {
    return this.get<CoalitionThemeResponse>(
      `${this.coalitionEndpoint}/get-coalition-theme-by-enrollment/${enrollmentId}`
    ).pipe(
      catchError((err) => {
        console.error(err);
        return of({} as CoalitionThemeResponse);
      }),
      map((response) => ('theme' in response ? mapToPortalTheme(response.theme, response.coalitionName) : null))
    );
  }

  getTpnData(coalitionId: string, serialNumber: string, sessionId: string, isSalesTeam: string) {
    return this.get<EnrollmentResponse>(`${this.coalitionEndpoint}/get-serial-number-data`, {
      serialNumber,
      coalitionId,
      sessionId,
      isSalesTeam,
    }).pipe(
      catchError((err) => {
        console.error(err);
        return of({});
      }),
      map(MapEnrollmentResponseToEnrollmentData)
    );
  }

  getTpnDataByEnrollmentId(enrollmentId: string) {
    return this.get<EnrollmentResponse>(`${this.enrollmentEndpoint}/${enrollmentId}/data`).pipe(
      catchError((err) => {
        console.error(err);
        return of({});
      }),
      map(MapEnrollmentResponseToEnrollmentData)
    );
  }
}

function mapToPortalTheme(value: string | any, coalitionName?: string): ApplicationProfilePortalTheme | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const themeData = typeof value === 'string' ? JSON.parse(value) : value;

  var applicationProfileTheme: ApplicationProfilePortalTheme = {
    Theme: mapToApplicationProfilePortalTheme(themeData.theme),
    PrimaryLogo: themeData.primaryLogo,
    SecondaryLogo: themeData.secondaryLogo,
    FavIcon: themeData.favIcon,
    CoalitionName: coalitionName,
  };

  return applicationProfileTheme;
}
